
export default function (Component) {
  Component.options.__source = "src/views/Messages/components/MessageContainer.vue"
}
